<template>
  <i
    :class="['general-icon', `icon-${icon}`]"
    v-html="require(`!html-loader!@assets/images/icons/${icon}.svg`)"
  >
  </i>
</template>

<script>
  
  export default {
    name: 'general-icon',
    props: {
      icon: {
        type: String,
        required: true,
      },
    },
  };

</script>
